import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';
import { NavLink } from 'react-router-dom';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import withTranslation from '@intelingu/core/utils/withTranslation';
import { AccountTab } from './tabs/AccountTab';
import { ProfileTab } from './tabs/ProfileTab';
import { SettingsTab } from './tabs/SettingsTab';

export interface ProfilePageProps extends RouteComponentProps<any> {
    t?;
}

@withTranslation(COMMON_NS)
@observer export class ProfilePage extends Component<ProfilePageProps, any> {

    render() {
        const { match, t } = this.props;

        return <div className={'profile-page'}>
            <h2 className={'page-title'}>{ t('profileTitle') }</h2>

            <div className="row">
                <div className="col-12 col-lg-3">
                    <div className="nav flex-column nav-pills" aria-orientation="vertical" style={{ marginBottom: 30 }}>
                        <NavLink to={`${match.url}/edit`} className={'nav-link'}>{ t('profileTabEdit') }</NavLink>
                        {/*<NavLink to={`${match.url}/settings`} className={'nav-link'}>Settings</NavLink>*/}
                        <NavLink to={`${match.url}/account`} className={'nav-link'}>{ t('profileTabAccount') }</NavLink>
                    </div>
                </div>
                <div className="col-12 col-lg-9">
                    <div className="tab-content">
                        <Switch>
                            <Route path={`${match.path}/account`} component={AccountTab} />
                            <Route path={`${match.path}/settings`} component={SettingsTab} />
                            <Route path={`${match.path}/edit`} component={ProfileTab} />
                        </Switch>
                    </div>
                </div>
            </div>
        </div>
    }

}
